import { buildQualifiedPath } from './fieldCatalogUtils';

function nodeHasRequiredDescendant(node) {
  if (node.required) {
    return true;
  }

  if (!node.children) {
    return false;
  }

  return Object.values(node.children).some((child) => nodeHasRequiredDescendant(child));
}

function nodeHasSftpPathPartyDescendant(node) {
  if (node.sftpPathParty) {
    return true;
  }

  if (!node.children) {
    return false;
  }

  return Object.values(node.children).some((child) => nodeHasSftpPathPartyDescendant(child));
}

function filterCatalogNode(node, path, query, requiredOnly) {
  const normalizedQuery = (query || '').trim().toLowerCase();
  const matchesQuery =
    !normalizedQuery ||
    path.toLowerCase().includes(normalizedQuery) ||
    node.kind.toLowerCase().includes(normalizedQuery);

  const filteredChildren = {};
  Object.entries(node.children || {}).forEach(([childName, childNode]) => {
    const childPath = buildQualifiedPath(path, childName);
    const filteredChild = filterCatalogNode(childNode, childPath, query, requiredOnly);

    if (filteredChild) {
      filteredChildren[childName] = filteredChild;
    }
  });

  const hasChildren = Object.keys(filteredChildren).length > 0;
  const keepForRequired =
    !requiredOnly ||
    node.required ||
    node.sftpPathParty ||
    nodeHasSftpPathPartyDescendant(node) ||
    nodeHasRequiredDescendant(node);

  if (!keepForRequired) {
    return null;
  }

  if (!matchesQuery && !hasChildren) {
    return null;
  }

  return {
    ...node,
    children: node.children ? filteredChildren : undefined,
  };
}

export function filterCatalogTree(tree, searchQuery, requiredOnly) {
  if (!tree) {
    return {};
  }

  const filtered = {};

  Object.entries(tree).forEach(([name, node]) => {
    const next = filterCatalogNode(node, name, searchQuery, requiredOnly);

    if (next) {
      filtered[name] = next;
    }
  });

  return filtered;
}
